import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
import { API_URL } from "../constants";
import Header from "../components/FrontPage/Header/Header";
import Loader from "../components/Dashboard/UI/Loader";

const SSO = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleSSOLogin = async () => {
      try {
        // Get redirect_uri from URL parameters
        const urlParams = new URLSearchParams(location.search);
        const redirectUri = urlParams.get("redirect_uri");

        if (!redirectUri) {
          setError("Missing redirect_uri parameter");
          setLoading(false);
          return;
        }

        // Check if user is authenticated
        const cookies = new Cookies();
        const token = cookies.get("tc_token");

        if (!token) {
          // Redirect to login with return URL
          const returnUrl = encodeURIComponent(window.location.href);
          window.location.href = `/log-in?returnUrl=${returnUrl}`;
          return;
        }

        // Make SSO request to backend with token in query parameter
        window.location.href = `${API_URL}/sso?redirect_uri=${encodeURIComponent(redirectUri)}&token=${encodeURIComponent(token)}`;
      } catch (error) {
        console.error("SSO error:", error);
        setError("An error occurred during SSO authentication");
        setLoading(false);
      }
    };

    handleSSOLogin();
  }, [location.search]);

  if (loading) {
    return (
      <>
        <Header />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "50vh",
            flexDirection: "column",
          }}
        >
          <Loader />
          <p style={{ marginTop: "20px" }}>Redirecting to Truck7...</p>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh",
          flexDirection: "column",
          padding: "20px",
        }}
      >
        <h2>SSO Authentication Error</h2>
        <p>{error}</p>
        <a href="/" style={{ marginTop: "20px" }}>
          Return to TransConnector
        </a>
      </div>
    </>
  );
};

export default SSO;
